import Chart from "react-apexcharts";
import { Stack } from "@bookingcom/bui-react";
import { t, useI18n } from "@bookingcom/lingojs-react";
import { ChartHeader } from "../ChartHeader";
import { ChartYaxisTitle } from "../ChartYaxisTitle";
import { useSearchCoverageChartController } from "./SearchCoverageChart.controller";
import { CHART_HEIGHT } from "../ChartConstants";
import type { Metric } from "../../../types/metrics";
import "../Charts.css";

export type SearchCoverageChartProps = { metric: Metric };

export const SearchCoverageChart = ({ metric }: SearchCoverageChartProps) => {
  const i18n = useI18n();
  const { averageCoverage, options, series } = useSearchCoverageChartController({ metric });

  return (
    <>
      <ChartHeader
        titleText={i18n.trans(t("flights_airline_portal_realtime_performance_metric_three_name"))}
        titleTooltipText={i18n.trans(t("flights_airline_portal_realtime_performance_metric_three_tooltip"))}
        subtitleText={i18n.trans(
          t("flights_airline_portal_realtime_performance_metric_three_subheader", {
            variables: { percent: averageCoverage },
          })
        )}
        subtitleValue={`${averageCoverage}%`}
      />
      <Stack mixin={{ position: "relative" }}>
        <ChartYaxisTitle titleText={i18n.trans(t("flights_airline_portal_realtime_performance_metric_three_yaxis"))} />
        <Chart options={options} series={series} type="bar" height={CHART_HEIGHT} />
      </Stack>
    </>
  );
};
